import clsx from 'clsx';

interface Props {
  className?: string;
  children: React.ReactNode;
  padding?: boolean;
  fullWidth?: boolean;
}

function Card({ className, padding, children, fullWidth }: Props): JSX.Element {
  return (
    <div
      className={clsx(
        'rounded-lg border border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-800',
        { 'p-4 sm:p-6 lg:p-8': padding },
        { 'max-w-sm': !fullWidth },
        className,
      )}
    >
      {children}
    </div>
  );
}

export default Card;
